import { render } from "./myLess.vue?vue&type=template&id=0a767f40&scoped=true"
import script from "./myLess.vue?vue&type=script&lang=js"
export * from "./myLess.vue?vue&type=script&lang=js"

import "./myLess.vue?vue&type=style&index=0&id=0a767f40&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a767f40"]])

export default __exports__